import { Controller } from "@hotwired/stimulus"

// USAGE: Add data-controller="enable-form-submit" to the form element and data-enable-form-submit-target="submitBtn" to the submit button
// EXAMPLE : See projects/subscriptions/electronic_sign.html.slim for an example
// NOTE : for now only checking checkboxes and radios and making sure all checkboxes and radios of each "name" are filled
export default class extends Controller {
  static targets = ["submitBtn"]

  connect() {
    this.checkboxes = Array.from(this.element.querySelectorAll("input[type='checkbox']"))
    this.radios = Array.from(this.element.querySelectorAll("input[type='radio']"))

    this.checkboxes.forEach(checkbox => {
      checkbox.addEventListener("change", () => this.updateSubmitButtonState())
    })
    this.radios.forEach(radio => {
      radio.addEventListener("change", () => this.updateSubmitButtonState())
    })
    this.updateSubmitButtonState()
  }

  updateSubmitButtonState() {
    const allCheckboxGroupsChecked = this.checkboxes.length > 0 
        ? Array.from(new Set(this.checkboxes.map(checkbox => checkbox.name))) // Get unique checkbox names
            .every(name => Array.from(this.checkboxes).some(checkbox => checkbox.name === name && checkbox.checked)) 
        : true;

    const allRadioGroupsChecked = this.radios.length > 0 
        ? Array.from(new Set(this.radios.map(radio => radio.name))) // Get unique radio names
            .every(name => Array.from(this.radios).some(radio => radio.name === name && radio.checked)) 
        : true;

    if (allCheckboxGroupsChecked && allRadioGroupsChecked) {
      this.submitBtnTarget.classList.remove("btn-disabled")
    } else {
      this.submitBtnTarget.classList.add("btn-disabled")
    }
  }
}